import React from 'react'

import { FeatureType } from '../constants/enums'
import { useConfiguration } from './useConfiguration'

export const useFeatureFlag = (flag: FeatureType) => {
  const configuration = useConfiguration()

  const getFlag = React.useCallback(
    () => Boolean(configuration.featureFlags[flag]),
    [configuration, flag],
  )
  const [on, setOn] = React.useState(getFlag())
  React.useEffect(() => {
    setOn(getFlag())
  }, [getFlag])

  return on
}
